!function(){
    function decodeContent(content) {
        try {
            return decodeURIComponent(window.atob(content).replace(/\+/g, "%20"));
        } catch (error) {
            console.error("Unable to decode obfuscated product tab content", error);
            return "";
        }
    }

    function replaceElementWithHtml(element, html) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        if (wrapper.childNodes.length > 0) {
            element.replaceWith(...wrapper.childNodes);
            return;
        }

        element.remove();
    }

    function renderEncodedContent(element) {
        const content = element.getAttribute("data-content");

        if (!content) {
            return;
        }

        replaceElementWithHtml(element, decodeContent(content));
    }

    function renderObfuscatedProductTabs() {
        document.querySelectorAll(".js-obfuscated-product-tab").forEach((element) => {
            if (element.hasAttribute("data-content")) {
                renderEncodedContent(element);
                return;
            }
        });
    }

    function initObfuscatedProductTabs() {
        renderObfuscatedProductTabs();

        if (document.documentElement.classList.contains("obfuscated-product-tabs-ready")) {
            return;
        }

        document.documentElement.classList.add("obfuscated-product-tabs-ready");

        const productTabs = document.querySelector("w3-product-tabs");

        if (!productTabs) {
            return;
        }

        new MutationObserver(() => {
            renderObfuscatedProductTabs();
        }).observe(productTabs, {childList: true, subtree: true});
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initObfuscatedProductTabs);
        return;
    }

    initObfuscatedProductTabs();
}();
